export default {
  inject: {
    client: { from: 'clientStore' },
    router: { from: 'routerStore' },
    accounts: { from: 'accountsStore' }
  },

  computed: {
    // Indicates that we are currently in development environment
    isDevelopmentEnvironment () {
      return this.client.isDevelopmentEnvironment
    },

    // Indicates that we are currently in mobile view
    isMobilePhone () {
      return this.client.isMobilePhone
    },

    // Ticker, used to enforce refreshing of stubborn computed properties
    ticker () {
      return this.client.ticker
    },

    // Google reCaptcha configuration
    reCaptcha () {
      return this.client.configuration.security.login.reCaptcha
    },

    // Indicates whether the window is ready for user interactions.
    // Sometimes reCaptcha is slow to initialize, this property helps locking the UI until it's ready.
    // Use client.ticker to force re-evaluation
    isReady () {
      const { ticker, reCaptcha, getReCaptchaService } = this
      if (reCaptcha && reCaptcha.enabled) {
        return ticker > 0 && getReCaptchaService() != null
      } else {
        return true
      }
    },
  },

  methods: {
    // Access to reCaptcha service
    getReCaptchaService () {
      return window.grecaptcha
    },

    // Executes the specified handler within secure context of reCaptcha service.
    // If reCaptcha is enabled, the handler will receive the received reCaptcha token,
    // which needs to be then validated on the server side.
    secure (handler) {
      const reCaptchaService = this.getReCaptchaService()
      const { reCaptcha } = this
      if (reCaptcha && reCaptchaService && reCaptcha.enabled) {
        reCaptchaService.ready(async () => {
          const token = await reCaptchaService.execute(reCaptcha.key, { action: 'submit' })
          if (token) {
            handler(token)
          }
        })
      } else {
        return handler()
      }
    }
  }
}
